import { Currency } from '../component/currency/objects/currency';

const USD_CURRENCY: Currency = {
    id: 150,
    symbol: '$',
    iso_code: 'USD',
    international_name: 'United States Dollar',
    usd_factor: '1',
    custom_currency: [],
    name: 'United States Dollar'
};

const AUD_CURRENCY: Currency = {
    id: 8,
    symbol: '$',
    iso_code: 'AUD',
    international_name: 'Australian Dollar',
    usd_factor: '1.53',
    custom_currency: [],
    name: 'Australian Dollar'
};

const EUR_CURRENCY: Currency = {
    id: 47,
    symbol: '€',
    iso_code: 'EUR',
    international_name: 'Euro',
    usd_factor: '0.9',
    custom_currency: [],
    name: 'Euro'
};

export const getDefaultCurrency = (quotation_code?: string | null): Currency => {
    // Prefer explicit quotation_code, otherwise use host subdomain
    const subDomain = typeof window !== 'undefined' ? window.location.host.split('.')[0] : '';
    const raw = quotation_code ?? subDomain ?? '';
    // Normalize input for matching (lowercase, strip punctuation)
    const normalized = String(raw).toLowerCase().replace(/[^a-z0-9]/g, '');

    const aliasMap: Record<string, Currency> = {
        // US dollar clients
        marcovasco: USD_CURRENCY,
        americavoyages: USD_CURRENCY,
        // AUD client
        luxeescapeholidays: AUD_CURRENCY,
    };

    if (aliasMap[normalized]) return aliasMap[normalized];
    return EUR_CURRENCY;
};

export const getDefaultCurrencyIsoCode = (quotation_code?: string | null): string => {
    return getDefaultCurrency(quotation_code).iso_code;
};

export const getDefaultCurrencySymbol = (quotation_code?: string | null): string => {
    return getDefaultCurrency(quotation_code).symbol;
};
